<div
  [ngClass]="tabStyleClass"
  [class.accordion-tab-active]="selected"
  [ngStyle]="tabStyle"
  [attr.data-pc-name]="'accordiontab'"
>
  <div
    role="heading"
    class="accordion-tab-header"
    [attr.aria-level]="headerAriaLevel"
    [attr.data-p-disabled]="disabled"
    [attr.data-pc-section]="'header'"
  >
    <a
      [ngStyle]="headerStyle"
      [ngClass]="headerClasses"
      class="accordion-tab-header__link"
      role="button"
      (click)="toggle($event)"
      [attr.tabindex]="disabled ? null : 0"
      [attr.aria-expanded]="selected"
      [attr.aria-disabled]="disabled"
      [attr.data-pc-section]="'headeraction'"
    >
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      <ng-container *ngIf="selected">
        <app-system-icon iconName="chevron-down" iconType="outline" [attr.aria-hidden]="true"></app-system-icon>
      </ng-container>
      <ng-container *ngIf="!selected">
        <app-system-icon iconName="chevron-right" iconType="outline" [attr.aria-hidden]="true"></app-system-icon>
      </ng-container>
    </a>
  </div>
  <div
    [@tabContent]="
      selected
        ? { value: 'visible', params: { transitionParams: transitionOptions } }
        : { value: 'hidden', params: { transitionParams: transitionOptions } }
    "
    role="region"
    class="overflow-hidden"
    [attr.aria-hidden]="!selected"
    [attr.data-pc-section]="'toggleablecontent'"
  >
    <div [ngStyle]="contentStyle" class="mx-1">
      <ng-content></ng-content>
      <ng-container *ngIf="bodyTemplate && (cache ? loaded : selected)">
        <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
      </ng-container>
    </div>
  </div>
</div>
